var _circle, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 9,
    ry: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.8a9 9 0 0 0 0 14.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.8a9 9 0 0 1 0 14.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 15.8l4.5-4.5-1.8-1.8-4.5 4.5 1 .8c.2.2.4.4.8 1z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18.5l3-0.7-2.3-2.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6h5v8h-5z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6v-2h1v2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6v-2h1v2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6v-2h1v2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4l0.5-1.5L7 2l-1.5-0.5L5 0l-0.5 1.5L3 2l1.5 0.5L5 4z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealmIcon);
export default __webpack_public_path__ + "static/media/realm_icon.1875d3bda3ec99a1a22aee8f34e8e732.svg";
export { ForwardRef as ReactComponent };